import moment from 'moment-timezone';

export interface RangePreset {
  label: string;
  value: string;
  getRange: () => any;
  component?: string;
}

// LOCAL refers to the time range being built in the local user's timezone
// FULL refers to the end timestamp being the end of the last day in the range
export const LAST_7_DAYS_RANGE_PRESET_LOCAL_FULL: RangePreset = {
  label: 'Last 7 days',
  value: 'week',
  getRange: () => {
    let end = moment().endOf('day');
    let start = end.clone().subtract(6, 'days').startOf('day');

    return { start, end };
  },
};

export const LAST_30_DAYS_RANGE_PRESET_LOCAL_FULL: RangePreset = {
  label: 'Last 30 days',
  value: 'month',
  getRange: () => {
    let end = moment().endOf('day');
    // We subtract 29 days to have a total of 30 days' worth of data
    let start = end.clone().subtract(29, 'days').startOf('day');

    return { start, end };
  },
};

export const LAST_12_WEEKS_FROM_NOW_RANGE_PRESET_LOCAL_FULL: RangePreset = {
  label: 'Last 12 weeks',
  value: 'weeks',
  getRange: () => {
    let end = moment().endOf('day');
    let start = end.clone().subtract(12, 'weeks').add(1, 'day');

    return { start, end };
  },
};

export const LAST_6_MONTHS_RANGE_PRESET_LOCAL_FULL: RangePreset = {
  label: 'Last 6 months',
  value: '6_months',
  getRange: () => {
    // Show the last 6 full months, including the current one
    let end = moment().endOf('day');
    let start = end.clone().subtract(6, 'months').startOf('day');

    return { start, end };
  },
};

export const LAST_12_MONTHS_RANGE_PRESET_LOCAL_FULL: RangePreset = {
  label: 'Last 12 months',
  value: 'months',
  getRange: () => {
    // Show the last 12 full months, including the current one
    let end = moment().endOf('day');
    let start = end.clone().subtract(12, 'months').add(1, 'day').startOf('day');

    return { start, end };
  },
};
